/** @jsxImportSource @emotion/react */
import { getTokenIn } from "../../../../utils/quoteUtils";
import React from "react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { getTakerTokens } from "../../../../store/global/selectors";
import { ReviewHeader } from "./elements/ReviewPayHeader";
import { css } from "@emotion/react";
import { amountFont, boldTokenFont } from "../../../../config/commonCSS";
import { getTokenIcon } from "../../../../utils/tokenIconUtils";

export interface YouPaySectionProps {
  shouldDisplayLabel: boolean;
  completed?: boolean;
}
export const YouPaySection: React.FC<YouPaySectionProps> = props => {
  const takerTokens = GlobalStore.useState(getTakerTokens);
  const tokens = GlobalStore.useState(s => s.tokens);
  const quote = GlobalStore.useState(s => s.quote);
  const wrapQuote = GlobalStore.useState(s => s.wrapQuote);
  const payText = props.completed ? "You Paid" : "You Pay";
  const theme = GlobalStore.useState(s => s.theme);

  if (!quote && !wrapQuote) {
    return null;
  }

  return (
    <div className="review-pay br-14">
      {props.shouldDisplayLabel && <ReviewHeader> {payText} </ReviewHeader>}
      {takerTokens.map((entry, index) => {
        const tokenName = tokens ? tokens[entry.token]?.name : entry.token;
        const amount = quote
          ? getTokenIn(quote, entry.token).amount.toDisplay(entry.token, tokens)
          : entry.amount.toDisplay(entry.token, tokens);
        return (
          <span key={entry.token}>
            <div className="d-flex align-items-center justify-content-between">
              <div
                key={entry.token}
                className="col pay-review-token"
                css={css`
                  ${boldTokenFont(theme)};
                  font-size: ${theme.fontSize["6"]};
                  max-width: 280px;
                  overflow-x: hidden;
                `}
              >
                <img
                  src={getTokenIcon(entry.token, tokens)}
                  style={{ marginRight: "10px" }}
                  alt={`${entry.token} symbol`}
                />
                {tokenName}
              </div>
              <div className="col d-flex flex-column align-items-end pay-review-token mt-2">
                <div>
                  <span css={amountFont(theme)} data-sentry-mask="true">
                    {amount}{" "}
                  </span>
                  <span
                    css={css`
                      ${boldTokenFont(theme)};
                      font-weight: 550;
                    `}
                  >
                    {entry.token}
                  </span>
                </div>
                {quote && (
                  <span
                    className="pay-review-usd"
                    css={css`
                      ${amountFont(theme)};
                      font-size: ${theme.fontSize["5"]};
                      font-weight: ${theme.fontWeights["work-sans-2"]};
                      color: #808b8b;
                    `}
                  >
                    ${getTokenIn(quote, entry.token).fiatValue.format(2)}
                  </span>
                )}
              </div>
            </div>
            {takerTokens.length > 0 && index !== takerTokens.length - 1 && (
              <hr className="hr-m-5" />
            )}
          </span>
        );
      })}
    </div>
  );
};
